import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-identity-verifier-wrapper', {
  mixins: [eventListenerMixin],

  properties: {
    triggerAction: {
      type: String,
      default: 'click',
    },
  },

  connected() {
    this.dialog = this.querySelector('.identity-verifier-dialog');

    this.listenTo(this.dialog, 'tr-identity-verifier:success', (event) => {
      this.dialog.close();
      event.stopPropagation();
      this.triggerSuccessEvent();
    });
    this.listenTo(this, {
      [`${this.triggerAction}`]: this.handleVerifyRequest.bind(this),
    });

    document.body.appendChild(this.dialog);
  },

  disconnected() {
    this.stopListening();
    document.body.removeChild(this.dialog);
  },

  handleVerifyRequest(e) {
    if (closest(e.target, '.identity-verifier-dialog')) return;

    e.preventDefault();
    e.stopPropagation();
    this.requestIdentityVerfier();
  },

  requestIdentityVerfier() {
    $.getJSON('/users/identity_verifier/new').then((result) => {
      if (result.identityVerified) {
        this.triggerSuccessEvent();
      } else {
        this.dialog.open();
      }
    });
  },

  triggerSuccessEvent() {
    const event = document.createEvent('Event');
    event.initEvent('tr-identity-verifier:success', true, true);
    this.dispatchEvent(event);
  },
});
